(function () {
  // App ------------------------------
  const firstSectionIds = ["s1q1", "s1q2", "s1q3", "s1q4", "s1q5"];
  const secondSectionIds = [
    "s2q1",
    "s2q2",
    "s2q3",
    "s2q4",
    "s2q5",
    "s2q6",
    "s2q7",
    "s2q8",
    "s2q9",
    "s2q10",
    "s2q11",
    "s2q12",
    "s2q13",
    "s2q14",
    "s2q15",
    "s2q16",
    "s2q17",
    "s2q18",
    "s2q19",
    "s2q20",
    "s2q21",
    "s2q22",
    "s2q23",
    "s2q24",
    "s2q25",
    "s2q26",
    "s2q27",
    "s2q28",
    "s2q29",
    "s2q30",
  ];
  // const thirdSectionIds = ["s3q1", "s3q2", "s3q3", "s3q4", "s3q5"];
  const root = document.getElementById("measureyourfatigue");
  //const thirdSectionQuestions = JSON.parse(root.dataset.s3qs);
  const secondSectionQuestions = JSON.parse(root.dataset.s2qs);
  function disableJQuery() {
    try {
      $("#email-results").validate({ ignore: "*" });
      $("#email-results").validate().settings.ignore = "*";
    } catch (error) {
      console.warn("Unable to remove JQuery form validation", error);
    }
  }

  // Listing app
  const MeasureYourFatigue = Vue.createApp({
    data() {
      return {
        // Defaults
        submitted: false,
        downloading: false,
        sendingEmail: false,
        emailAddressIsValid: false,
        showValidation: false,
        emailSendSuccess: false,
        emailAddress: "",
        emailErrorMessage: "",
        firstSectionSubmitted: false,
        secondSectionSubmitted: false,
        // Section 1
        s1q1: undefined,
        s1q2: undefined,
        s1q3: undefined,
        s1q4: undefined,
        s1q5: undefined,
        // Weirdos
        secondSectionQuestions: secondSectionQuestions,
        secondSectionNAs: ["s2q3", "s2q4", "s2q9", "s2q12", "s2q13", "s2q14"],
        secondSectionAnswers: {
          s2q1: undefined,
          s2q2: undefined,
          s2q3: undefined,
          s2q4: undefined,
          s2q5: undefined,
          s2q6: undefined,
          s2q7: undefined,
          s2q8: undefined,
          s2q9: undefined,
          s2q10: undefined,
          s2q11: undefined,
          s2q12: undefined,
          s2q13: undefined,
          s2q14: undefined,
          s2q15: undefined,
          s2q16: undefined,
          s2q17: undefined,
          s2q18: undefined,
          s2q19: undefined,
          s2q20: undefined,
          s2q21: undefined,
          s2q22: undefined,
          s2q23: undefined,
          s2q24: undefined,
          s2q25: undefined,
          s2q26: undefined,
          s2q27: undefined,
          s2q28: undefined,
          s2q29: undefined,
          s2q30: undefined,
        },
        //// Section 3
        //s3q1: "",
        //s3q2: "",
        //s3q3: "",
        //s3q4: "",
        //s3q5: "",
        // Results
        firstSectionScore: `0/${firstSectionIds.length * 4}`,
        secondSectionScore: `0/${secondSectionIds.length * 4}`,
      };
    },
    computed: {
      isFirstSectionCompleted: function () {
        return firstSectionIds.every((id) => this[id] !== undefined);
      },
      isSecondSectionCompleted: function () {
        return secondSectionIds.every(
          (id) => this.secondSectionAnswers[id] !== undefined
        );
      },
      secondSectionMaxScore: function () {
        return secondSectionIds.length * 4;
      },
    },
    methods: {
      print: function () {
        window.print();
      },
      submitFirstSection: function () {
        this.firstSectionSubmitted = true;
      },
      submitSecondSection: function () {
        this.secondSectionSubmitted = true;
      },
      calculateFirstSection: function (event) {
        event.preventDefault();
        const t = this;

        if (!t.firstSectionSubmitted && !t.isFirstSectionCompleted) {
          return (t.firstSectionScore = `0/${firstSectionIds.length * 4}`);
        }

        t.firstSectionScore = `${firstSectionIds.reduce((acc, id) => {
          return acc + parseInt(t[id] || "0");
        }, 0)}/${firstSectionIds.length * 4}`;
      },
      calculateSecondSection: function (event) {
        event.preventDefault();
        const t = this;

        if (!t.secondSectionSubmitted && !t.isSecondSectionCompleted) {
            t.secondSectionScore = `0/${t.secondSectionMaxScore}`;
          return;
        }

        const naAnswersCount = secondSectionIds
          .filter(
            // Filter N/A answers
            (id) => t.secondSectionAnswers[id] === "n/a"
          )
          .length;

        // the score needs to be adjusted by compensating the effect of N/A answers
        const compensationFactor = t.secondSectionMaxScore / (t.secondSectionMaxScore - (naAnswersCount * 4));

        const secondSectionScore = Math.round(secondSectionIds
          .filter(
            // Filter out N/A answers
            (id) => t.secondSectionAnswers[id] !== "n/a"
          )
          .reduce((acc, id) => {
            return acc + parseInt(t.secondSectionAnswers[id] || "0");
          }, 0) * compensationFactor);

         t.secondSectionScore = `${secondSectionScore}/${t.secondSectionMaxScore}`;
      },
      downloadPdf: function (event) {
        event.preventDefault();
        const t = this;

        if (!t.emailAddressIsValid) {
          t.emailErrorMessage = "Please enter a valid email address";
          return;
        }

        t.submitted = true;

        if (!t.isFirstSectionCompleted) {
          t.emailErrorMessage =
            "You must answer all questions in section 1 before emailing your results";
          return;
        }

        if (!t.firstSectionSubmitted) {
          t.emailErrorMessage =
            "You must submit section 1 before emailing your results";
          return;
        }

        if (!t.isSecondSectionCompleted) {
          t.emailErrorMessage =
            "You must answer all questions in section 2 before emailing your results";
          return;
        }

        if (!t.secondSectionSubmitted) {
          t.emailErrorMessage =
            "You must submit section 2 before emailing your results";
          return;
        }

        t.emailErrorMessage = "";
        t.downloading = true;

        $.post("/umbraco/api/measureyourfatigueapi/sendemail", {
          emailAddress: t.emailAddress,
          // Email invards
          firstSectionScore: t.firstSectionScore, // Something like "x/y" where y is the total number of questions without N/A answers
          secondSectionScore: t.secondSectionScore,
          //// Third section consists of the questions and answers
          //thirdSectionQuestions: [
          //  {
          //    question: thirdSectionQuestions.s3q1,
          //    answer: t.s3q1 || "Unanswered",
          //  },
          //  {
          //    question: thirdSectionQuestions.s3q2,
          //    answer: t.s3q2 || "Unanswered",
          //  },
          //  {
          //    question: thirdSectionQuestions.s3q3,
          //    answer: t.s3q3 || "Unanswered",
          //  },
          //  {
          //    question: thirdSectionQuestions.s3q4,
          //    answer: t.s3q4 || "Unanswered",
          //  },
          //  {
          //    question: thirdSectionQuestions.s3q5,
          //    answer: t.s3q5 || "Unanswered",
          //  },
          //],
        })
          .done(function (response) {
            if (response.success) {
              t.emailSendSuccess = true;
            } else {
              // alert('failed');
              console.warn(response);
            }
          })
          .always(function () {
            t.downloading = false;
          });
      },
      isValidEmail: function () {
        const t = this;
        const regex =
          /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        t.emailAddressIsValid = regex.test(t.emailAddress);
        t.showValidation = true;
        disableJQuery(); // just for any case. Can't test it in dev environment cus this issue doesn't happen in windows, but happens in Linux and Macos. The JQuery validates the email field and doubles the email errors.
      },
      reset: function () {
        const t = this;
        t.downloading = false;
        t.sendingEmail = false;
        t.emailAddressIsValid = false;
        t.showValidation = false;
        t.emailSendSuccess = "";
        t.emailAddress = "";
      },
    },
  });
  const vm = MeasureYourFatigue.mount("#measureyourfatigue");
  disableJQuery();
})();

String.prototype.toSentenceCase = function () {
  return this.charAt(0).toUpperCase() + this.substr(1).toLowerCase();
};
